import React from 'react';
import { useNavigate } from 'react-router-dom'
import './breadcrumbs.css'

function BreadCrumbs(props) {
    const [breadCrumbs, setBreadcrumbs] = React.useState([]);
    const navigate = useNavigate()
    React.useEffect(() => {
        setBreadcrumbs(props.data);
    }, [props]);

    const titleClick = (breadcrumb) => {
       
        if (breadcrumb.state) {
            navigate(breadcrumb.path, breadcrumb.state)
        }
        else {
            window.location.href = breadcrumb.path
        }
    }

    return (
        <ul className="breadcrumb">
            {breadCrumbs !== undefined
                ? breadCrumbs?.map((breadcrumb, index) => {
                    return breadcrumb.isActive ? (
                        <li key={index}>
                            <a className='cursor' onClick={() => { titleClick(breadcrumb) }} >{breadcrumb.title}</a>
                        </li>
                    ) : (
                        <li className='pe-2' style={{ color: "#647A90" }}>{breadcrumb.title}</li>
                    );
                })
                : null}
        </ul>
    );
}

export default BreadCrumbs;
